"use client"
import { useState, useEffect } from "react"

const useMouse = () => {
  const [mouse, setMouse] = useState(false)
  useEffect(() => {
    const checkForMouseDown = (e: MouseEvent) => {
      if (e?.type === "mousedown") {
        setMouse(true)
      }
    }

    const checkForTab = (e: KeyboardEvent) => {
      if (e?.keyCode === 9) {
        setMouse(false)
      }
    }

    // must check if document exists due to Gatsby - documentation recommendation: https://www.gatsbyjs.com/docs/debugging-html-builds/
    if (typeof document !== "undefined" && document.body) {
      document.body.addEventListener("mousedown", checkForMouseDown)
      document.body.addEventListener("keydown", checkForTab)

      return () => {
        // Cleanup event listeners on unmount
        if (typeof document !== "undefined" && document.body) {
          document.body.removeEventListener("keydown", checkForTab)
          document.body.removeEventListener("mousedown", checkForMouseDown)
        }
      }
    }
  }, [])

  return {
    mouse,
  }
}

export default useMouse
